(() => {
  const landing = document.querySelector('.pitb-landing');
  if (!landing) return;

  const isHomepage =
    document.body.classList.contains('template-index') ||
    document.body.className.includes('template-index');

  const isCatalogPage =
    Boolean(document.querySelector('[data-pitb-all-catalog]')) ||
    document.body.classList.contains('pitb-catalog-route');
  const isSearchPage =
    Boolean(document.querySelector('[data-pitb-search-page]')) ||
    document.body.classList.contains('pitb-search-route');

  const getStickyOffset = () => {
    const header = document.querySelector('.shopify-section-group-header-group');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    return Math.max(headerHeight, 72) + 12;
  };

  const scrollToShop = (behavior = 'auto') => {
    const target =
      document.getElementById('pitb-shop-toolbar') || document.getElementById('pitb-preorder');
    if (!target) return false;

    const top = target.getBoundingClientRect().top + window.pageYOffset - getStickyOffset();
    window.scrollTo({ top: Math.max(0, top), behavior });
    return true;
  };

  const focusShopView = (behavior = 'smooth') => {
    scrollToShop('auto');
    requestAnimationFrame(() => scrollToShop('auto'));
    setTimeout(() => scrollToShop(behavior), 80);
    setTimeout(() => scrollToShop('auto'), 450);
  };

  const scrollToId = (id, behavior = 'smooth') => {
    if (id === 'pitb-preorder') return scrollToShop(behavior);
    const target = document.getElementById(id);
    if (!target) return false;
    target.scrollIntoView({ behavior, block: 'start' });
    return true;
  };

  const normalizeFilter = (value) => {
    const filter = (value || 'all').toLowerCase();
    if (filter === 'pitb-preorder') return 'all';
    return filter;
  };

  const shouldFocusPreorder = () => {
    if (window.location.hash === '#pitb-preorder') return true;
    return new URLSearchParams(window.location.search).has('pitb_filter');
  };

  const focusPreorderOnLoad = () => {
    if (!shouldFocusPreorder()) return;
    focusShopView('auto');
    window.addEventListener('load', () => focusShopView('auto'), { once: true });
  };

  landing.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    const id = (link.getAttribute('href') || '').slice(1);
    if (!id) return;

    if (id === 'pitb-notify' || link.hasAttribute('data-pitb-notify')) {
      event.preventDefault();
      if (window.PITBNotify && typeof window.PITBNotify.open === 'function') {
        window.PITBNotify.open(link);
      }
      return;
    }

    if (scrollToId(id)) {
      event.preventDefault();
      history.replaceState(null, '', `#${id}`);
    }
  });

  /* Swap hero Book/Cart to PDP chrome once product pre-order grid is in view */
  const actions = landing.querySelector('.pitb-landing__hero-actions');
  const actionsSlot = landing.querySelector('.pitb-landing__actions-slot');
  const navToolbar = actionsSlot && actionsSlot.querySelector('.pitb-nav-toolbar');
  const preorderAnchor = document.getElementById('pitb-preorder');
  const mobileMq = window.matchMedia('(max-width: 749px)');

  const getStickTop = () => {
    const raw = getComputedStyle(landing).getPropertyValue('--pitb-hero-bar-top');
    const parsed = Number.parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : 24;
  };

  const syncStickyActions = () => {
    if (!actions || !actionsSlot) return;

    if (document.body.classList.contains('pitb-early-access-on')) {
      actions.classList.remove('is-stuck');
      actionsSlot.classList.remove('is-stuck');
      if (navToolbar) navToolbar.classList.remove('is-stuck');
      return;
    }

    const stickyTarget = navToolbar || actions;
    if (!actionsSlot.classList.contains('is-stuck')) {
      actionsSlot.style.setProperty('--pitb-actions-h', `${stickyTarget.offsetHeight}px`);
      actionsSlot.style.setProperty('--pitb-actions-w', `${stickyTarget.offsetWidth}px`);
    }

    const stuck = actionsSlot.getBoundingClientRect().top <= getStickTop();
    actions.classList.toggle('is-stuck', stuck);
    actionsSlot.classList.toggle('is-stuck', stuck);
    if (navToolbar) navToolbar.classList.toggle('is-stuck', stuck);
  };

  if (actions && preorderAnchor && isHomepage) {
    const bookBtn = actions.querySelector('a.pitb-landing__btn--white, a.pitb-pdp__btn-book');
    const cartBtn = actions.querySelector('[data-pitb-cart-btn]');
    const bagImg = cartBtn && cartBtn.querySelector('.pitb-landing__bag');

    const setPreorderChrome = (on) => {
      actions.classList.toggle('is-on-preorder', on);
      landing.classList.toggle('pitb-landing--preorder-chrome', on);
      if (bookBtn) {
        bookBtn.classList.toggle('pitb-landing__btn--white', !on);
        bookBtn.classList.toggle('pitb-pdp__btn-book', on);
      }
      if (cartBtn) {
        cartBtn.classList.toggle('pitb-landing__btn--cart', !on);
        cartBtn.classList.toggle('pitb-pdp__btn-cart', on);
      }
      if (bagImg) bagImg.classList.toggle('pitb-pdp__bag', on);
    };

    const syncChrome = () => {
      const top = preorderAnchor.getBoundingClientRect().top;
      setPreorderChrome(top <= 72);
      syncStickyActions();
    };

    syncChrome();
    window.addEventListener('scroll', syncChrome, { passive: true });
    window.addEventListener('resize', syncChrome);
    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', syncChrome);
    } else if (typeof mobileMq.addListener === 'function') {
      mobileMq.addListener(syncChrome);
    }
  } else if (actions && actionsSlot) {
    syncStickyActions();
    window.addEventListener('scroll', syncStickyActions, { passive: true });
    window.addEventListener('resize', syncStickyActions);
    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', syncStickyActions);
    } else if (typeof mobileMq.addListener === 'function') {
      mobileMq.addListener(syncStickyActions);
    }
  }

  const filters = document.querySelector('[data-pitb-filters]');
  const shop = document.querySelector('[data-pitb-shop]');
  const shopBody = shop && shop.querySelector('[data-pitb-shop-body]');
  const sortRoot = shop && shop.querySelector('[data-pitb-sort]');
  const sortToggle = sortRoot && sortRoot.querySelector('[data-pitb-sort-toggle]');
  const sortMenu = sortRoot && sortRoot.querySelector('[data-pitb-sort-menu]');
  const landingSectionId = 'pitb_landing';

  let activeSort = '';
  let activeCategoryFilter = 'all';
  let pagerLoading = false;

  const grid = () => shop && shop.querySelector('[data-pitb-grid]');
  const empty = () => shop && shop.querySelector('[data-pitb-empty]');

  const cards = () => {
    const node = grid();
    return node ? Array.from(node.querySelectorAll('[data-pitb-card]')) : [];
  };

  const setActiveFilter = (activeLink) => {
    if (!filters || !activeLink) return;
    filters.querySelectorAll('a[data-filter]').forEach((link) => {
      const active = link === activeLink;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  };

  const setActiveFilterFromUrl = () => {
    if (!filters) return;
    const urlFilter = new URLSearchParams(window.location.search).get('pitb_filter') || 'all';
    const key = normalizeFilter(urlFilter);
    const activeLink =
      filters.querySelector(`a[data-filter="${key}"]`) ||
      (key === 'all' ? filters.querySelector('a[data-filter="all"]') : null);
    if (activeLink) setActiveFilter(activeLink);
  };

  const applyCategoryFilter = () => {
    const key = normalizeFilter(activeCategoryFilter);
    const onlyAvailable = activeSort === 'available';
    let shown = 0;
    cards().forEach((card) => {
      const collections = (card.getAttribute('data-collections') || '').split(',');
      const categoryOk = key === 'all' || collections.includes(key);
      const availableOk = !onlyAvailable || card.getAttribute('data-available') === '1';
      const show = categoryOk && availableOk;
      card.hidden = !show;
      if (show) shown += 1;
    });
    const emptyNode = empty();
    if (emptyNode) emptyNode.hidden = shown > 0;
  };

  const applyAvailableFilter = () => {
    applyCategoryFilter();
  };

  const applySort = () => {
    const node = grid();
    if (!node || !activeSort || activeSort === 'available') return;
    const list = cards();
    list.sort((a, b) => {
      const priceA = Number(a.getAttribute('data-price') || 0);
      const priceB = Number(b.getAttribute('data-price') || 0);
      const titleA = a.getAttribute('data-title') || '';
      const titleB = b.getAttribute('data-title') || '';

      if (activeSort === 'price-asc') return priceA - priceB || titleA.localeCompare(titleB);
      if (activeSort === 'price-desc') return priceB - priceA || titleA.localeCompare(titleB);
      return 0;
    });
    list.forEach((card) => node.appendChild(card));
  };

  const refresh = () => {
    applyCategoryFilter();
    applyAvailableFilter();
    applySort();
  };

  /* Collection Liquid cards can show stale sold-out; refresh from product.js (same as PDP). */
  const ATC_SVG =
    '<svg class="pitb-pc__atc-icon" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><circle class="pitb-pc__atc-round" cx="20" cy="20" r="19" fill="#F3F4F6" stroke="transparent" stroke-width="2"></circle><path class="pitb-pc__atc-bag" d="M14.5659 29.353C13.9887 29.353 13.4968 29.1497 13.0903 28.7432C12.6837 28.3367 12.4805 27.8448 12.4805 27.2676V16.4869C12.4805 15.9096 12.6837 15.4176 13.0903 15.0111C13.4968 14.6047 13.9887 14.4015 14.5659 14.4015H16.2074C16.2184 13.3638 16.5936 12.4787 17.3328 11.7461C18.0721 11.0134 18.9609 10.647 19.9992 10.647C21.0373 10.647 21.9264 11.0134 22.6665 11.7461C23.4064 12.4787 23.7818 13.3638 23.7928 14.4015H25.4343C26.0115 14.4015 26.5034 14.6047 26.9099 15.0111C27.3165 15.4176 27.5198 15.9096 27.5198 16.4869V27.2676C27.5198 27.8448 27.3165 28.3367 26.9099 28.7432C26.5034 29.1497 26.0115 29.353 25.4343 29.353H14.5659ZM14.5659 27.2676H25.4343V16.4869H23.7928V18.1942C23.7928 18.4868 23.6922 18.7337 23.491 18.9349C23.2896 19.1362 23.0427 19.2369 22.7501 19.2369C22.4575 19.2369 22.2106 19.1362 22.0092 18.9349C21.808 18.7337 21.7074 18.4868 21.7074 18.1942V16.4869H18.2928V18.1942C18.2928 18.4868 18.1922 18.7337 17.991 18.9349C17.7896 19.1362 17.5427 19.2369 17.2501 19.2369C16.9575 19.2369 16.7106 19.1362 16.5092 18.9349C16.308 18.7337 16.2074 18.4868 16.2074 18.1942V16.4869H14.5659V27.2676ZM18.2983 14.4015H21.7019C21.6909 13.9412 21.5203 13.5479 21.1902 13.2217C20.86 12.8956 20.4632 12.7325 19.9997 12.7325C19.536 12.7325 19.1392 12.8956 18.8094 13.2217C18.4797 13.5479 18.3093 13.9412 18.2983 14.4015Z" fill="#1A191A"></path></svg>';

  const productJsCache = new Map();

  const fetchProductJs = (handle) => {
    if (productJsCache.has(handle)) return productJsCache.get(handle);
    const req = fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null);
    productJsCache.set(handle, req);
    return req;
  };

  const cardHandle = (card) => {
    if (card.dataset.handle) return card.dataset.handle;
    const href =
      card.querySelector('a.pitb-pc__media[href], a[href*="/products/"]')?.getAttribute('href') ||
      '';
    const match = href.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const isInviteTag = (tag) => {
    const normalized = String(tag || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-');
    return (
      normalized === 'pitb-invite-only' ||
      normalized === 'by-invite-only' ||
      normalized === 'by_invite_only' ||
      normalized === 'by-invited-only' ||
      normalized === 'by_invited_only' ||
      normalized === 'invite-only' ||
      normalized === 'invited-only'
    );
  };

  const isInviteCard = (card) => {
    if (card.querySelector('.pitb-pc__badge--invite')) return true;
    const tags = String(card.dataset.tags || '')
      .toLowerCase()
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean);
    return tags.some(isInviteTag);
  };

  const shopPurchasesClosed = () =>
    Boolean(shop?.classList.contains('pitb-landing__shop--closed')) ||
    Boolean(
      window.PITB_ORDER_CAP && (window.PITB_ORDER_CAP.closeState || window.PITB_ORDER_CAP.fullyBooked)
    );

  const applyFreshAvailability = (card, product) => {
    if (!product) return;
    const variants = product.variants || [];
    const variant = variants.find((v) => v.available) || variants[0] || null;
    const available = Boolean(product.available && variant && variant.available);
    card.dataset.available = available ? '1' : '0';

    const media = card.querySelector('.pitb-pc__media');
    if (!media) return;
    const inviteOnly =
      isInviteCard(card) ||
      (Array.isArray(product.tags) && product.tags.some(isInviteTag));
    const soldBadge = media.querySelector('.pitb-pc__badge--soldout');
    const inviteBadge = media.querySelector('.pitb-pc__badge--invite');
    const row = card.querySelector('.pitb-pc__row');
    const addWrap = card.querySelector('.pitb-pc__add');

    // Invite tag + still available → invite badge only. Sold-out invite falls through to Sold Out.
    if (inviteOnly && available) {
      soldBadge?.remove();
      if (!inviteBadge) {
        const badge = document.createElement('span');
        badge.className = 'pitb-pc__badge pitb-pc__badge--invite';
        badge.textContent = 'By Invite Only';
        media.appendChild(badge);
      }
      addWrap?.remove();
      return;
    }

    if (!available) {
      inviteBadge?.remove();
      if (shopPurchasesClosed()) {
        // Closed state sells nothing online, so the badge would land on every card and
        // tell the shopper nothing. Mirrors pitb-product-card.liquid / catalog-search.
        soldBadge?.remove();
      } else if (!soldBadge) {
        const badge = document.createElement('span');
        badge.className = 'pitb-pc__badge pitb-pc__badge--soldout';
        badge.textContent = inviteOnly ? 'Sold Out' : 'Sold Out Online';
        media.appendChild(badge);
      }
      addWrap?.remove();
      return;
    }

    soldBadge?.remove();
    if (shopPurchasesClosed() || !variant || !row) return;

    if (!addWrap) {
      const title = product.title || card.getAttribute('data-title') || 'product';
      const safeTitle = String(title).replace(/"/g, '&quot;');
      const productForm = document.createElement('product-form');
      productForm.className = 'pitb-pc__add';
      productForm.innerHTML = `<form method="post" action="/cart/add" class="pitb-pc__form" novalidate="novalidate" data-pitb-handle="${String(product.handle || '').replace(/[^\w-]/g, '')}" data-pitb-limit="${window.PITBQuantityLimit?.limitAttr(product.tags) ?? ''}"><input type="hidden" name="id" value="${variant.id}"><input type="hidden" name="quantity" value="1"><button type="submit" class="pitb-pc__atc" name="add" aria-label="Add ${safeTitle} to cart">${ATC_SVG}</button></form>`;
      row.appendChild(productForm);
    } else {
      const idInput = addWrap.querySelector('input[name="id"]');
      if (idInput) idInput.value = String(variant.id);
    }
  };

  const syncShopCardAvailability = async () => {
    const list = cards();
    if (!list.length) return;

    let index = 0;
    const concurrency = Math.min(6, list.length);
    await Promise.all(
      Array.from({ length: concurrency }, async () => {
        while (index < list.length) {
          const card = list[index++];
          const handle = cardHandle(card);
          if (!handle) continue;
          const product = await fetchProductJs(handle);
          applyFreshAvailability(card, product);
        }
      })
    );
    refresh();
  };

  const withScrollLock = (fn) => {
    const x = window.scrollX;
    const y = window.scrollY;
    fn();
    window.scrollTo(x, y);
    requestAnimationFrame(() => window.scrollTo(x, y));
  };

  const closeSortMenu = () => {
    if (!sortMenu || !sortToggle) return;
    sortMenu.hidden = true;
    sortToggle.setAttribute('aria-expanded', 'false');
    sortRoot.classList.remove('is-open');
  };

  const openSortMenu = () => {
    if (!sortMenu || !sortToggle) return;
    withScrollLock(() => {
      sortMenu.hidden = false;
      sortToggle.setAttribute('aria-expanded', 'true');
      sortRoot.classList.add('is-open');
    });
  };

  const bindSort = () => {
    if (!sortRoot || !sortToggle || !sortMenu || sortRoot.dataset.pitbSortBound === '1') return;
    sortRoot.dataset.pitbSortBound = '1';

    sortToggle.addEventListener('mousedown', (event) => {
      event.preventDefault();
    });

    sortToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      withScrollLock(() => {
        if (sortMenu.hidden) openSortMenu();
        else closeSortMenu();
      });
    });

    sortMenu.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-sort]');
      if (!btn) return;
      event.preventDefault();
      activeSort = btn.getAttribute('data-sort') || '';
      sortMenu.querySelectorAll('[data-sort]').forEach((el) => {
        el.classList.toggle('is-active', el === btn);
        el.parentElement?.setAttribute('aria-selected', el === btn ? 'true' : 'false');
      });
      withScrollLock(() => {
        closeSortMenu();
        if (shop) {
          shop.classList.add('is-loading');
          const loader = shop.querySelector('[data-pitb-shop-loading]');
          if (loader) {
            loader.hidden = false;
            loader.setAttribute('aria-hidden', 'false');
          }
        }
        requestAnimationFrame(() => {
          refresh();
          setTimeout(() => {
            if (!shop) return;
            shop.classList.remove('is-loading');
            const loader = shop.querySelector('[data-pitb-shop-loading]');
            if (loader) {
              loader.hidden = true;
              loader.setAttribute('aria-hidden', 'true');
            }
          }, 280);
        });
      });
    });
  };

  if (sortRoot) {
    bindSort();
    document.addEventListener('click', (event) => {
      if (!sortRoot.contains(event.target)) closeSortMenu();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeSortMenu();
    });
  }

  const filterFromCollectionHandle = (handle) => {
    if (!handle || handle === 'pitb-preorder') return 'all';
    return handle;
  };

  const buildHomepageFetchUrl = (targetUrl) => {
    const url = new URL(targetUrl, window.location.origin);
    const params = new URLSearchParams();
    params.set('sections', landingSectionId);

    const page = url.searchParams.get('page');
    if (page) params.set('page', page);

    const collectionMatch = url.pathname.match(/\/collections\/([^/?#]+)/);
    if (collectionMatch) {
      const filter = filterFromCollectionHandle(collectionMatch[1]);
      if (filter !== 'all') params.set('pitb_filter', filter);
    } else {
      url.searchParams.forEach((value, key) => {
        if (key !== 'sections') params.set(key, value);
      });
    }

    return `${window.Shopify?.routes?.root || '/'}?${params.toString()}`;
  };

  const syncFilterState = (nextShop) => {
    if (!filters || !nextShop) return;
    const nextFilters = nextShop.querySelector('[data-pitb-filters]');
    if (!nextFilters) return;

    filters.querySelectorAll('a[data-filter]').forEach((link) => {
      const key = link.getAttribute('data-filter');
      const nextLink = nextFilters.querySelector(`a[data-filter="${key}"]`);
      if (!nextLink) return;
      const active = nextLink.classList.contains('is-active');
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  };

  const swapShopBody = (html) => {
    const wrap = document.createElement('div');
    wrap.innerHTML = html;
    const nextShop = wrap.querySelector('[data-pitb-shop]');
    const nextBody = nextShop && nextShop.querySelector('[data-pitb-shop-body]');
    if (!shopBody || !nextBody) return false;
    shopBody.innerHTML = nextBody.innerHTML;
    if (nextShop && shop) {
      ['pitbTotalCount', 'pitbTotalPages', 'pitbPerPage', 'pitbCatalogUrl', 'pitbFilter'].forEach((key) => {
        if (nextShop.dataset[key] != null) shop.dataset[key] = nextShop.dataset[key];
      });
    }
    syncFilterState(nextShop);
    ensurePager();
    refresh();
    return true;
  };

  const buildPagerHref = (page, catalogUrl, filter) => {
    const base = catalogUrl || (isHomepage ? '/' : '/collections/pitb-preorder');
    const url = new URL(base, window.location.origin);
    url.searchParams.set('page', String(page));
    if (filter && filter !== 'all' && filter !== 'pitb-preorder') {
      url.searchParams.set('pitb_filter', filter);
    } else {
      url.searchParams.delete('pitb_filter');
    }
    url.hash = 'pitb-preorder';
    return `${url.pathname}${url.search}${url.hash}`;
  };

  const pagerWindow = (current, total, size = 3) => {
    if (total <= size) return { start: 1, end: total };
    let start = Math.max(1, current - Math.floor(size / 2));
    let end = start + size - 1;
    if (end > total) {
      end = total;
      start = Math.max(1, end - size + 1);
    }
    return { start, end };
  };

  const ensurePager = () => {
    const root = document.querySelector('[data-pitb-shop]');
    const body = root && root.querySelector('[data-pitb-shop-body]');
    if (!root || !body) return;

    const totalPages = Number(root.dataset.pitbTotalPages || 0);
    if (totalPages <= 1 || body.querySelector('[data-pitb-pager]')) return;

    const currentPage = Number(new URL(window.location.href).searchParams.get('page') || '1');
    const catalogUrl = root.dataset.pitbCatalogUrl || '/collections/pitb-preorder';
    const filter = root.dataset.pitbFilter || 'all';
    const totalCount = root.dataset.pitbTotalCount || '';
    const { start, end } = pagerWindow(currentPage, totalPages);

    const nav = document.createElement('nav');
    nav.className = 'pitb-landing__pager';
    nav.setAttribute('aria-label', 'Product pagination');
    nav.setAttribute('data-pitb-pager', '');

    const list = document.createElement('ul');
    list.className = 'pitb-landing__pager-list';

    for (let page = 1; page <= totalPages; page += 1) {
      const li = document.createElement('li');
      li.setAttribute('data-pitb-pager-page', String(page));
      if (page >= start && page <= end) li.classList.add('is-in-window');
      if (page === currentPage) {
        const current = document.createElement('span');
        current.className = 'pitb-landing__pager-link is-current';
        current.setAttribute('aria-current', 'page');
        current.textContent = String(page);
        li.appendChild(current);
      } else {
        const link = document.createElement('a');
        link.className = 'pitb-landing__pager-link';
        link.href = buildPagerHref(page, catalogUrl, filter);
        link.dataset.pitbPage = String(page);
        link.textContent = String(page);
        li.appendChild(link);
      }
      list.appendChild(li);
    }

    nav.appendChild(list);

    const meta = document.createElement('p');
    meta.className = 'pitb-landing__pager-meta';
    meta.textContent = totalCount
      ? `Page ${currentPage} of ${totalPages} · ${totalCount} products`
      : `Page ${currentPage} of ${totalPages}`;
    nav.appendChild(meta);

    body.appendChild(nav);
  };

  const loadShopPage = async (targetUrl, pushUrl) => {
    if (!isHomepage || !shopBody || pagerLoading) return false;
    pagerLoading = true;
    shop.classList.add('is-loading');

    try {
      const fetchUrl = buildHomepageFetchUrl(targetUrl);
      const response = await fetch(fetchUrl);
      const data = await response.json();
      const sectionHtml = data[landingSectionId];
      if (!sectionHtml || !swapShopBody(sectionHtml)) {
        window.location.assign(targetUrl);
        return false;
      }

      const resolvedPush =
        pushUrl ||
        fetchUrl
          .replace(`sections=${landingSectionId}&`, '')
          .replace(`&sections=${landingSectionId}`, '')
          .replace(`?sections=${landingSectionId}`, '?');
      const pushTarget = resolvedPush.includes('#') ? resolvedPush : `${resolvedPush}#pitb-preorder`;
      history.pushState(null, '', pushTarget);
      focusShopView('smooth');
      syncShopCardAvailability();
      return true;
    } catch (_error) {
      window.location.assign(targetUrl);
      return false;
    } finally {
      pagerLoading = false;
      shop.classList.remove('is-loading');
    }
  };

  const buildHomepagePushUrl = (linkUrl, filterOverride) => {
    const pushParams = new URLSearchParams();
    const page = linkUrl.searchParams.get('page');
    if (page && Number(page) > 1) pushParams.set('page', page);

    let filter = filterOverride;
    if (filter == null) {
      filter = linkUrl.searchParams.get('pitb_filter');
      const collectionMatch = linkUrl.pathname.match(/\/collections\/([^/?#]+)/);
      if (collectionMatch) filter = filterFromCollectionHandle(collectionMatch[1]);
    }

    if (filter && filter !== 'all') pushParams.set('pitb_filter', filter);
    const pushQuery = pushParams.toString();
    return `${window.location.pathname}${pushQuery ? `?${pushQuery}` : ''}`;
  };

  const buildCatalogPushUrl = (query, filter) => {
    const base =
      (shop && shop.dataset.pitbCatalogUrl) || window.location.pathname || '/products';
    let pathname = '/products';
    try {
      pathname = new URL(base, window.location.origin).pathname || pathname;
    } catch (_error) {
      if (typeof base === 'string' && base.charAt(0) === '/') pathname = base.split('?')[0];
    }

    const params = new URLSearchParams();
    if (query) params.set('q', query);
    const key = normalizeFilter(filter || 'all');
    if (key !== 'all') params.set('pitb_filter', key);
    const qs = params.toString();
    return `${pathname}${qs ? `?${qs}` : ''}`;
  };

  const buildSearchPushUrl = (query, filter) => {
    const params = new URLSearchParams();
    if (query) params.set('q', query);
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    const key = normalizeFilter(filter || 'all');
    if (key !== 'all') params.set('pitb_filter', key);
    return `/search?${params.toString()}`;
  };

  if (filters) {
    filters.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-filter]');
      if (!link) return;
      event.preventDefault();
      event.stopPropagation();

      const filterKey = link.getAttribute('data-filter') || 'all';
      setActiveFilter(link);

      const linkUrl = new URL(link.href, window.location.origin);
      const query =
        new URLSearchParams(window.location.search).get('q')?.trim() ||
        linkUrl.searchParams.get('q')?.trim() ||
        '';

      if (isCatalogPage) {
        activeCategoryFilter = filterKey;
        history.pushState(null, '', buildCatalogPushUrl(query, filterKey));
        document.dispatchEvent(new CustomEvent('pitb:catalog-filter-changed'));
        return;
      }

      if (isSearchPage) {
        activeCategoryFilter = filterKey;
        if (shop) shop.classList.add('pitb-landing__shop--search');
        history.pushState(null, '', buildSearchPushUrl(query, filterKey));
        document.dispatchEvent(new CustomEvent('pitb:catalog-filter-changed'));
        return;
      }

      focusShopView('smooth');

      if (!isHomepage || !shopBody) {
        window.location.assign(link.href);
        return;
      }

      // Category chips filter by product tag, but the Liquid grid only holds one page of
      // 24, so it can't filter the full 110-product set — chips used to navigate to
      // /collections/pitb-preorder for that reason. pitb-catalog-search.js holds the
      // complete set, so hand off to it and filter in place instead. Its listener awaits
      // its own catalog load, so this is safe even before the fetch finishes.
      if (window.PITB_JS_GRID) {
        activeCategoryFilter = filterKey;
        history.pushState(null, '', buildHomepagePushUrl(linkUrl, filterKey));
        document.dispatchEvent(new CustomEvent('pitb:catalog-filter-changed'));
        return;
      }

      // No JS grid (engine absent) — only "All" can be served from Liquid.
      if (filterKey !== 'all') {
        window.location.assign(
          `/collections/pitb-preorder?pitb_filter=${encodeURIComponent(filterKey)}`
        );
        return;
      }

      linkUrl.searchParams.delete('page');
      linkUrl.searchParams.delete('pitb_filter');
      const target = `${linkUrl.pathname}${linkUrl.search}${linkUrl.hash || '#pitb-preorder'}`;
      const pushUrl = buildHomepagePushUrl(linkUrl, 'all');
      loadShopPage(target, pushUrl);
    });
  }

  if (shop) {
    shop.addEventListener('click', (event) => {
      const pagerLink = event.target.closest('[data-pitb-pager] a[href], a.pitb-landing__pager-link[href]');
      if (!pagerLink || !isHomepage) return;
      // pitb-catalog-search.js owns pagination once the full catalog is loaded (its pager
      // pages a client-side filtered list that Liquid can't reproduce). Yield to it.
      if (window.PITB_JS_GRID?.ready()) return;
      event.preventDefault();
      focusShopView('auto');
      const linkUrl = new URL(pagerLink.href, window.location.origin);
      const pushUrl = buildHomepagePushUrl(linkUrl);
      loadShopPage(pagerLink.href, pushUrl);
    });
  }

  // Back/forward after in-place filtering changes the grid (pitb-catalog-search.js
  // re-renders on popstate) but left the chip highlight on the old category, so the
  // toolbar disagreed with the products on screen. Re-sync the highlight from the URL.
  window.addEventListener('popstate', () => {
    if (!filters) return;
    activeCategoryFilter = new URLSearchParams(window.location.search).get('pitb_filter') || 'all';
    setActiveFilterFromUrl();
  });

  if (isCatalogPage && shopBody) {
    const current = new URL(window.location.href);
    activeCategoryFilter = current.searchParams.get('pitb_filter') || 'all';
    setActiveFilterFromUrl();
    /* Category grids are server-rendered for full collection counts */
    syncShopCardAvailability();
  }

  if (isSearchPage && shopBody) {
    const current = new URL(window.location.href);
    activeCategoryFilter = current.searchParams.get('pitb_filter') || 'all';
    setActiveFilterFromUrl();
    /* Full-result filtering + pagination is handled by pitb-catalog-search.js */
  }

  if (isHomepage && shopBody) {
    const current = new URL(window.location.href);
    const initialPage = Number(current.searchParams.get('page') || '1');
    const urlFilter = current.searchParams.get('pitb_filter');

    setActiveFilterFromUrl();

    // Deep-linked category filters (e.g. /?pitb_filter=pitb-figures) used to redirect
    // to /collections/pitb-preorder. pitb-catalog-search.js now handles them here by
    // loading the complete filtered set, so stay on the homepage.
    const deepLinkedCategory = urlFilter && urlFilter !== 'all' && urlFilter !== 'pitb-preorder';
    if (deepLinkedCategory) {
      activeCategoryFilter = urlFilter;
      return;
    }

    if (urlFilter || initialPage > 1) {
      shop?.classList.add('is-loading');
      loadShopPage(window.location.href, buildHomepagePushUrl(current, urlFilter || 'all'));
    } else {
      ensurePager();
      focusPreorderOnLoad();
      syncShopCardAvailability();
    }
  }

  document.addEventListener('pitb:search-results-loaded', () => {
    /* Keep active sort when JS grid re-renders; category already applied. */
    if (
      isSearchPage ||
      (shop &&
        (shop.classList.contains('pitb-landing__shop--search') ||
          shop.classList.contains('pitb-landing__shop--browse')))
    ) {
      applySort();
      /* JS cards from products.json — availability already fixed in catalog-search */
      return;
    }
    refresh();
    syncShopCardAvailability();
  });

  if (!grid()) return;
})();
